import { Pool } from "../../../Utils/Collections/Pool";
import { Platform } from "./Platform";
import { NodeList } from "../../../Utils/Collections/NodeList";
import { Node } from "../../../Utils/Collections/Node";
import { ViewCellMapRow } from "../View/ViewCellMapRow";

export class PlatformManager {
    /**
     * (RO) Staticky pristup
     */
    static get instance(): PlatformManager { return PlatformManager._INSTANCE; }
    private static _INSTANCE: PlatformManager;

    /**
     * Pool s volnymi plosinami
     */
    private _freePlatforms: Pool<Platform>;

    /**
     * Seznam aktivnich plosin
     */
    private _actPlatforms: NodeList<Platform>;

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    constructor() {
        PlatformManager._INSTANCE = this;

        this._freePlatforms = new Pool<Platform>(Platform, 2, true);
        this._actPlatforms = new NodeList<Platform>();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    reset(): void {
        // Uvolnit aktivni plosiny
        this._actPlatforms.forEach((plat: Platform) => {
            plat.release();
            this._freePlatforms.returnItem(plat);
        });
        this._actPlatforms.clear();
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    update(): void {
        // Volat update() pro aktivni plosiny
        this._actPlatforms.forEach((plat: Platform, node: Node<Platform>) => {
            if (!plat.update()) {
                this._actPlatforms.removeByNode(node);
                plat.release();
                this._freePlatforms.returnItem(plat);
            }
        });
    }

    //-------------------------------------------------------------------------
    //-------------------------------------------------------------------------
    initPlatform(width: number, cellId: number, row: ViewCellMapRow): Platform {
        let plat = this._freePlatforms.getItem();

        plat.init(width, cellId, row);
        this._actPlatforms.add(plat);

        return plat;
    }
}